__turbopack_context__.v({
  "body": "StudentAffairsContactsModal-module__Mfydaq__body",
  "contactCard": "StudentAffairsContactsModal-module__Mfydaq__contactCard",
  "contactInfo": "StudentAffairsContactsModal-module__Mfydaq__contactInfo",
  "contactName": "StudentAffairsContactsModal-module__Mfydaq__contactName",
  "contactPhone": "StudentAffairsContactsModal-module__Mfydaq__contactPhone",
  "contactPhoneRow": "StudentAffairsContactsModal-module__Mfydaq__contactPhoneRow",
  "contactRole": "StudentAffairsContactsModal-module__Mfydaq__contactRole",
  "contactsList": "StudentAffairsContactsModal-module__Mfydaq__contactsList",
  "header": "StudentAffairsContactsModal-module__Mfydaq__header",
  "mainIconWrapper": "StudentAffairsContactsModal-module__Mfydaq__mainIconWrapper",
  "phoneIcon": "StudentAffairsContactsModal-module__Mfydaq__phoneIcon",
  "roleIcon": "StudentAffairsContactsModal-module__Mfydaq__roleIcon",
  "section": "StudentAffairsContactsModal-module__Mfydaq__section",
  "sectionLabel": "StudentAffairsContactsModal-module__Mfydaq__sectionLabel",
  "socialIconWrapper": "StudentAffairsContactsModal-module__Mfydaq__socialIconWrapper",
  "title": "StudentAffairsContactsModal-module__Mfydaq__title",
});
